import { memo } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Brain, LineChart, Database, Users, Globe } from "lucide-react";

const dimensions = [
  {
    icon: Brain,
    title: "Strategy & Leadership",
    description: "Evaluate organizational AI vision, leadership commitment, and strategic planning for AI initiatives."
  },
  {
    icon: Database,
    title: "Data & Infrastructure",
    description: "Assess data readiness, quality, and technological infrastructure supporting AI implementations."
  },
  {
    icon: Users,
    title: "Talent & Skills",
    description: "Measure the availability and capability of AI-trained workforce and development programs."
  },
  {
    icon: LineChart,
    title: "Use Case Deployment",
    description: "Analyze the implementation success and business impact of existing AI projects and initiatives."
  },
  {
    icon: Globe,
    title: "Innovation & Ecosystem",
    description: "Evaluate AI-driven partnerships, external collaboration, and innovation ecosystem engagement."
  }
] as const;

const CoreDimensionsSectionComponent = () => {
  return (
    <section className="py-12 sm:py-20 bg-white">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#0f2d69] text-center mb-8 sm:mb-12">
          Core Dimensions
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {dimensions.map((dimension, index) => (
            <Card 
              key={index} 
              className="border-none shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 bg-white/50 backdrop-blur-sm"
            >
              <CardHeader>
                <div className="flex items-start gap-3">
                  <div className="p-2 bg-[#0f2d69]/5 rounded-lg group-hover:bg-[#0f2d69]/10 transition-colors">
                    <dimension.icon className="h-6 w-6 text-[#0f2d69]" />
                  </div>
                  <CardTitle className="text-lg sm:text-xl">{dimension.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm sm:text-base text-gray-600">{dimension.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

const CoreDimensionsSection = memo(CoreDimensionsSectionComponent);
export default CoreDimensionsSection;
